<app-header></app-header>
<div class="page-content">
  <h1 class="webapp-title">Seguimiento</h1>
  <p>Controla el progreso en todos los procesos que tienes en curso. Completa los items de cada lista para avanzar con los requisitos obligatorios.</p>
  
  <!-- CLIENT PROCESS CONTROL -->
  <app-client-process *ngIf="isUserLogged()"></app-client-process>
  
    <!-- Checklist Section -->
<!--     <div class="section checklist-section">
      <h3>Task Checklists</h3>
      <div *ngFor="let checklist of checklists">
        <div class="card mb-3 shadow-sm">
          <div class="card-header">
            <h5>{{ checklist.name }}</h5>
          </div>
          <ul class="list-group list-group-flush">
            <li *ngFor="let item of checklist.items" class="list-group-item">
              <div class="d-flex justify-content-between">
                <div>
                  <input type="checkbox" [(ngModel)]="item.completed" (change)="toggleCompleted(item)">
                  <span [class.completed]="item.completed">{{ item.item }}</span>
                  <i class="fas fa-edit" (click)="editTask(item)"></i>
                </div>
                <div>
                  <span *ngIf="item.dueDate !== '0000-00-00 00:00:00'">{{ item.dueDate | date }}</span>
                </div>
              </div>
              <small class="text-muted" *ngIf="item.description">{{ item.description }}</small>
            </li>
          </ul>
        </div>
      </div>
    </div> -->

    <div *ngIf="!isUserLogged()">
      <h2 class="webapp-title-secondary">Así se verán tus procesos</h2>
      <span class="medium-gray-title">Ejemplo</span>
      <app-checklist></app-checklist>
    </div>

    <!-- Locked Content -->
  <!-- <app-smart-card
    cardType="locked"
    title="Locked Feature"
    description="Unlock this feature by upgrading."
    imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
    badgeText="LOCKED"
    ctaText="Upgrade"
    (ctaClicked)="handleCta('locked')">
  </app-smart-card> -->

  <app-smart-card
    cardType="coming-soon"
    title="Locked Feature"
    description="Unlock this feature by upgrading."
    imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
    badgeText="LOCKED"
    ctaText="Upgrade"
    (ctaClicked)="handleCta('locked')">
  </app-smart-card>

  

  
    <!-- Important Dates Section -->
    <!-- <div class="section dates-section">
      <h3>Important Dates</h3>
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let date of importantDates">
          <strong>{{ date.title }}:</strong> {{ date.date | date }}
          <i class="fas fa-edit" (click)="editDate(date)"></i>
        </li>
      </ul>
    </div> -->
  
    <!-- Reminders Section -->
    <!-- <div class="section reminders-section">
      <h3>Reminders</h3>
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let reminder of reminders">
          {{ reminder.text }}
          <i class="fas fa-edit" (click)="editReminder(reminder)"></i>
        </li>
      </ul>
      <button class="btn btn-primary" (click)="addReminder()">Add Reminder</button>
    </div> -->
</div>
<app-footer></app-footer>
